//

export class DashColors {
    //https://flatuicolors.com/
    public static colors=["#EBC05D", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"];
    public static Ordencolors2=["#28C76F", "#EA5455", "#EBC05D", "#FF9F43", "#1E1E1E"];
    public static Uniccolors=["#EBC05D", "#EBC05D", "#EBC05D", "#EBC05D", "#EBC05D"];
    public static palettecanadian=["#7EB043", "#feca57", "#ff6b6b", "#1dd1a1", "#54a0ff", "#01a3a4", "#5f27cd", "#10ac84", "#341f97", "#ee5253", "#ff9f43", "#c8d6e5", "#f368e0", "#576574", "#0abde3"];
}
